import React, { useState, useEffect } from "react";
import PageTitle from "../common/PageTitle";
import { Container, Row, Col } from "shards-react";
import { Button } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import axios from "axios";
import api from "../common/api";
import ConfirmDialog from "../common/ConfirmDialog";
const useStyles = theme => ({
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "white"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  checkedIcon: {
    width: 16,
    height: 16
  },
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  typography: {
    fontSize: "0.75rem"
  },
  select: {
    marginTop: "0",
    marginRight: "12px",
    padding: "0"
  },
  menu: {
    fontSize: "0.75rem"
  }
});

function DashboardUser(props) {
  const [subcontact, setSubContact] = useState({});
  const [user, setUser] = useState({ password_set: false });
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [errors, setErrors] = useState({});

  const saveUser = async () => {
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    formData.set("subcontact_id", subcontact.id);
    formData.set("subcontact[firstname]", subcontact.firstname);
    formData.set("subcontact[lastname]", subcontact.lastname);
    formData.set("name", subcontact.firstname + " " + subcontact.lastname);
    formData.set("email", user.email);
    if (user.password_set) {
      var regex = /^[0-9]+$/;
      if (!regex.test(user.password) || user.password.length !== 6) {
        setError(true);
        setDialogOpen(true);
        setMessage("La contraseña debe tener solo 6 números.");
        return;
      }
      formData.set("password", user.password);
    }
    var url = api.dashboardUsers().post();
    if (user && user.id) {
      formData.set("id", user.id);
      formData.set("user_id", user.id);
      url = api.users().patch(user.id);
      formData.set("_method", "PATCH");
    }
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        setError(false);
        setDialogOpen(true);
        setMessage("El usuario se creó con éxito");
      })
      .catch(function(error) {
        var promise = new Promise(function(resolve, reject) {
          resolve(error.response.data);
          setErrors(error.response.data);
        });
        setError(true);
        setDialogOpen(true);
        setMessage("Ha ocurrido un error al crear el usuario");
      });
  };

  const getSubcontact = async id => {
    const token = localStorage.getItem("userToken");
    const url = api.subcontacts().getMobileSubcontact(id) + "?user_type=4";
    return await axios
      .get(url, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var subcontact_res = response.data;
        if (response.data.subcontact) {
          subcontact_res = response.data.subcontact;
        }
        setSubContact(subcontact_res);
        if (subcontact_res.user_id && subcontact_res.user) {
          setUser(subcontact_res.user);
        } else {
          setUser({ ...user, email: subcontact_res.contact.email });
        }
        setLoading(false);
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  const handleRedirect = () => {
    window.location.href = "/dashboard/users";
  };
  useEffect(() => {
    const id = props.match.params.subcontact_id;
    getSubcontact(id);
  }, []);

  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle
          sm="12"
          title={
            subcontact && user.id
              ? "Usuario Dashboard"
              : "Nuevo usuario dashboard"
          }
          className="text-sm-left"
        />
      </Row>
      <Row>
        <ConfirmDialog
          confirm_dialog={dialogOpen}
          title={"Usuario dashboard"}
          message={message}
          onClose={() => {
            setDialogOpen(false);
          }}
          onAccept={() => {
            !error ? handleRedirect() : setDialogOpen(false);
          }}
          onCancel={() => {
            setDialogOpen(false);
          }}
          errors={errors}
        />
        {!loading && (
          <>
            <Col md="12">
              <React.Fragment>
                <TextField
                  id="firstname"
                  value={subcontact.firstname}
                  disabled={user ? false : true}
                  onChange={val => {
                    setSubContact({
                      ...subcontact,
                      firstname: val.target.value
                    });
                  }}
                  fullWidth
                  type="text"
                  name="firstname"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Nombre</Typography>
                      </InputAdornment>
                    )
                  }}
                />
                <TextField
                  id="lastname"
                  value={subcontact.lastname}
                  disabled={user ? false : true}
                  onChange={val => {
                    setSubContact({
                      ...subcontact,
                      lastname: val.target.value
                    });
                  }}
                  fullWidth
                  type="text"
                  name="lastname"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Apellido</Typography>
                      </InputAdornment>
                    )
                  }}
                />
                <TextField
                  id="email"
                  value={user.email}
                  disabled={user && user.id > 0 ? true : false}
                  onChange={val => {
                    setUser({ ...user, email: val.target.value });
                  }}
                  fullWidth
                  type="text"
                  name="email"
                  margin="normal"
                  className="m-t-2 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Email</Typography>
                      </InputAdornment>
                    )
                  }}
                />
                {user && user.id && (
                  <TextField
                    id="password"
                    value={user.password}
                    onChange={val => {
                      setUser({
                        ...user,
                        password: val.target.value,
                        password_set: true
                      });
                    }}
                    fullWidth
                    type="text"
                    name="password"
                    margin="normal"
                    className="m-0 p-0 mr-2"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      style: { minWidth: 70, fontSize: "0.75rem" }
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Typography variant="caption">Contraseña</Typography>
                        </InputAdornment>
                      )
                    }}
                  />
                )}
                <TextField
                  id="hansa_code"
                  value={subcontact.contact.hansa_code}
                  disabled
                  fullWidth
                  type="text"
                  name="hansa_code"
                  margin="normal"
                  className="m-t-2 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 70, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Cod Hansa</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              </React.Fragment>
            </Col>
            <Col md="12">
              {subcontact && !user.id ? (
                <Button
                  className="mt-2"
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ fontSize: "0.75rem" }}
                  onClick={() => {
                    saveUser();
                  }}
                >
                  Crear usuario
                </Button>
              ) : (
                <>
                  <Button
                    className="mt-2"
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ fontSize: "0.75rem" }}
                    onClick={() => {
                      saveUser();
                    }}
                  >
                    Guardar usuario
                  </Button>
                </>
              )}
            </Col>
          </>
        )}
      </Row>
    </Container>
  );
}

export default withStyles(useStyles)(DashboardUser);
